<template lang="html">
  <div class="analytic">
    <div id="cardholder">
      <div id="statscard">
        <LoadingSection title="Analytics" :loading="false" :autoPadding="false">
          <template v-slot:content>
            <div class="section-field flex-box wrap">
              <h3 class="black pull-left bgap-24">Total Views</h3>
              <div class="right pull-right flex-box wrap section-gap gray">
                <div class="summary-stat gray">
                  <div class="descriptor bgap-4">All Time</div>
                  <div id="total-views-all-time" class="body-17"></div>
                </div>
                <div class="summary-stat">
                  <div class="descriptor bgap-4">Last 30 days</div>
                  <div id="total-views-30-days" class="body-17"></div>
                </div>
              </div>
            </div>

            <div class="section-field flex-box wrap">
              <h3 class="black pull-left bgap-24">Top five jurisdictions</h3>
              <div class="right pull-right flex-box wrap section-gap gray">
                <div class="summary-stat">
                  <div class="descriptor bgap-4">All Time</div>
                  <div id="top-jurs-all-time" class="body-17"></div>
                </div>
                <div class="summary-stat">
                  <div class="descriptor bgap-4">Last 30 days</div>
                  <div id="top-jurs-30-days" class="body-17"></div>
                </div>
              </div>
            </div> </template
        ></LoadingSection>
      </div>
    </div>

    <div class="section-field" id="addchartcard">
      <div class="bgap-32" @click="addnewchart">
        <div class="body-16-medium purple cursor-pointer-hover-underline">
          Add Chart
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSection from 'src/components/dashboard/shares/LoadingSection.vue'

export default {
  components: { LoadingSection },
  methods: {
    addnewchart() {
      this.$analytic.addnewchart()
    },
  },
}
</script>

<style lang="css" scoped>
@import url('https://rsms.me/inter/inter.css');

/* Tooltip styling start*/
div.google-visualization-tooltip {
  margin-left: 0 !important;
  margin-top: 0px !important;
  z-index: +1;
  background-color: #fcfcff;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: 0px 2px 8px rgba(81, 96, 236, 0.15) !important;
}

div.google-visualization-tooltip > ul > li > span {
  color: #21275b !important;
  font-size: 16px !important;
}

ul.google-visualization-tooltip-item-list {
  padding: 8px !important;
  margin: 0 !important;
}

li.google-visualization-tooltip-item {
  padding: 0 !important;
  margin: 0 !important;
}

.row.graph-card {
  margin-left: 0;
}

.section-gap {
  row-gap: 32px;
}

.summary-stat {
  min-width: 186px;
}

/* Tooltip styling end*/
</style>
